import { useQuery } from "@tanstack/react-query";
import dateFormat from "dateformat";
import React from "react";
import { Helmet } from "react-helmet";
import { useParams } from "react-router-dom";
import Footer from "../components/footer";
import Header from "../components/header";
import Spinner from "../components/spinner";
import TopNavabr from "../components/topNavabr";
import { BASE_URL, IMAGE_BASE_URL } from "../data/baseURL";
import { useScrollTop } from "../hook/useScrollTop";

const Magazine = () => {
  const { id } = useParams();
  const { data, isLoading, isError } = useQuery(["magazine"], async () => {
    const response = await window.fetch(`${BASE_URL}/magazine-details/${id}`);
    return await response.json();
  });

  const { data: banner } = useQuery(["banner"], async () => {
    const response = await window.fetch(`${BASE_URL}/banner`);
    return await response.json();
  });

  useScrollTop();

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    throw new Error();
  }

  return (
    <>
      <Helmet>
        <title>AFRO || Magazine</title>
      </Helmet>
      <TopNavabr />
      <Header
        bannerBackground={Boolean(banner?.banner?.default) ? "video" : "image"}
        videoURL={banner?.banner?.video}
        imageURL={banner?.banner?.image}
      >
        <div className="pt-7 pb-7 text-center">
          <h1 className="fs-56 gilroy-bold text-center text-white header-background-image-size">
            Afro Magazine
          </h1>
        </div>
      </Header>
      <section className="container-fluid pt-7 pb-13">
        <div className="ms-35 me-35">
          <div>
            <img
              src={`${IMAGE_BASE_URL}/${data?.magazine?.image_banner}`}
              className="img-fluid w-100"
              alt=""
            />
          </div>
          <article>
            <div className="h-100 blog-card">
              <div className="card-body blog-card-body-padding fs-20">
                <div className="position-relative">
                  {/* <img
                    // src={`${IMAGE_BASE_URL}/${data?.magazine?.image}`}
                    src={magazineCover}
                    style={{ height: "37rem", objectFit: "cover" }}
                    className="card-img-top w-full d-block rounded object-cover"
                    loading="lazy"
                    alt="..."
                  /> */}
                  {/* <p className="blog-img-text fs-16 bg-american-yellow text-white fw-700 rounded">
                    {data?.magazine?.heading}
                  </p> */}
                </div>
                <p className="fs-16 d-flex justify-content-end">
                  <p className="badge bg-american-yellow px-3 py-3 my-2">
                    {dateFormat(data?.magazine?.created_at, "dS mmmm, yyyy")}
                  </p>
                </p>
                <p className="fs-22 gilroy-bold text-charleston-green">
                  {data?.magazine?.title}
                </p>
                <p
                  className="fs-16 text-align-justify"
                  dangerouslySetInnerHTML={{
                    __html: data?.magazine?.description,
                  }}
                />

                {/* <p
                  className="text-spanish-gray"
                  dangerouslySetInnerHTML={{
                    __html: data?.magazine?.description,
                  }}
                /> */}
              </div>
            </div>
          </article>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Magazine;
